module.exports = __webpack_public_path__ + "img/lose_lottery4_small.a336add7.png";